
import { saveAs } from 'file-saver';
import { useEffect, useState } from 'react';
import DataTableGrid from '../../../shared/formUtilities/useTable';
import { InitializeColumnsDFSA } from '../reportsColumn';
import { ReportsService } from '../reportsService';
import { DateHelper } from '../../../helpers/dateHelper';
import { CsvHelper } from '../../../helpers/csvHelper';

const DFSAReport = () => {
  const reportsService = new ReportsService();
  const [reports, setReports] = useState([]);
  const [loading, setloading] = useState(false);
  const [columns, setColumn] = useState(InitializeColumnsDFSA());

  useEffect(() => {
    getAll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getTotal = (data = []) => {
    return data.reduce(
      (totals, item) => {
        totals.investorsCount += item.investorsCount || 0;
        totals.borrowersCount += item.borrowersCount || 0;
        return totals;
      },
      { investorsCount: 0, borrowersCount: 0 }
    );
  };

  const getAll = () => {
    setloading(true);
    reportsService
      .getDFSAReport()
      .then((resp) => {
        setloading(false);
        setReports(resp.data);
        let total = getTotal(resp.data);
        setColumn([...InitializeColumnsDFSA(total.investorsCount, total.borrowersCount)]);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const onDownloadCSV = () => {
    let report = [...reports];
    report.push({ regionName: 'total', investorsCount: getTotal(reports).investorsCount, borrowersCount: getTotal(reports).borrowersCount });
    const csv = CsvHelper.serializeArrayToCsv(report);
    const blob = new Blob([csv], {
      type: 'application/json',
    });
    const date = DateHelper.formatDate(new Date());
    const fileName = `DFSA-Report-${date}.csv`;
    saveAs(blob, fileName);
  };

  return (
    <>
      <DataTableGrid
        showDownloadCSV={true}
        download={() => {
          onDownloadCSV();
        }}
        name={'dfsaReportTbl'}
        columns={columns}
        hideSerialNumbers
        heading={'DFSA Report'}
        records={reports}
        isPagination={false}
        showEditColumnsButton={true}
        loading={loading}></DataTableGrid>
    </>
  );
};

export default DFSAReport;
